import React, { FC } from 'react'

import { IconBonusProps } from './IconBonus.types'
import * as Styled from './styles/IconBonus.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBonus: FC<IconBonusProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBonusProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconBonusProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M156 48h-45.14c6.21-2.56 9-4.58 10.07-5.51a4 4 0 0 0 .39-.35A20 20 0 0 0 93 13.86C87.24 19.66 82 39.4 80 48c-6.11-26.16-11.91-33-13.12-34.21a20 20 0 0 0-28.27 28.27l.07.07c2.07 2.07 5.91 4.06 10.39 5.86H4a4 4 0 0 0-4 4V76a4 4 0 0 0 4 4h3.82v68a4 4 0 0 0 4 4h136a4 4 0 0 0 4-4V80H156a4 4 0 0 0 4-4V52a4 4 0 0 0-4-4zM72 80h16v64H72zm0-8V56h16v16zm26.7-52.48a12 12 0 0 1 17.17 16.77l-.21.2c-3.11 3.11-16.11 7.31-27.07 10.11 2.8-10.97 6.99-23.97 10.11-27.08zM44.41 20a12 12 0 0 1 16.89-.5c3.11 3.11 7.31 16.11 10.11 27.07-10.92-2.79-23.87-7-27-10.08a12 12 0 0 1 0-16.49zM8 56h56v16H8zm7.82 24H64v64H15.82zm128 64H96V80h47.82zM152 72H96V56h56z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBonus
